// Central content + media for the Sarrgosa Kasauli landing page.

export const IMAGES = {
  heroBalcony: "/assets/hero-studio-3d.webp",
  heroMobile: "/assets/hero-mobile.webp",
  lawnApartments: "/assets/lawn-apartments.webp",
  studioInterior: "/assets/studio-interior.webp",
  onebhkLiving: "/assets/onebhk-living.webp",
  interiorNook: "/assets/interior-nook.webp",
  facadeSummer: "/assets/facade-summer.webp",
  facadeWinter: "/assets/facade-winter.webp",
  diamondLogo: "/assets/diamond-builders-logo.webp",
  hills:
    "https://images.unsplash.com/photo-1782813947861-51b3d64c61b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxIaW1hbGF5YW4lMjBwaW5lJTIwZm9yZXN0JTIwaGlsbHMlMjBtaXN0fGVufDB8fHx8MTc4NjQyNTIwMXww&ixlib=rb-4.1.0&q=85",
  forest:
    "https://images.unsplash.com/photo-1786040721789-ac866dfa20c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxIaW1hbGF5YW4lMjBwaW5lJTIwZm9yZXN0JTIwaGlsbHMlMjBtaXN0fGVufDB8fHx8MTc4NjQyNTIwMXww&ixlib=rb-4.1.0&q=85",
  pool:
    "https://images.unsplash.com/photo-1783502255807-95764c49d321?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxpbmZpbml0eSUyMHBvb2wlMjBtb3VudGFpbiUyMHJlc29ydCUyMGR1c2t8ZW58MHx8fHwxNzg2NDI1MjAxfDA&ixlib=rb-4.1.0&q=85",
  spa:
    "https://images.unsplash.com/photo-1676302144341-10563603f99a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcGElMjB3ZWxsbmVzcyUyMGludGVyaW9yJTIwd2FybXxlbnwwfHx8fDE3ODY0MjUyMDF8MA&ixlib=rb-4.1.0&q=85",
  sauna:
    "https://images.unsplash.com/photo-1583416750470-965b2707b355?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBzcGElMjB3ZWxsbmVzcyUyMGludGVyaW9yJTIwd2FybXxlbnwwfHx8fDE3ODY0MjUyMDF8MA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBhcGFydG1lbnQlMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg2NDI1MjAxfDA&ixlib=rb-4.1.0&q=85",
  familyWalk:
    "https://images.unsplash.com/photo-1770196567087-b59ba06aef12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGZhbWlseSUyMG1vdW50YWluJTIwcmV0cmVhdCUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3ODY0MjUyMDF8MA&ixlib=rb-4.1.0&q=85",
  familyPath:
    "https://images.unsplash.com/photo-1761839271800-f44070ff0eb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxoYXBweSUyMGZhbWlseSUyMG1vdW50YWluJTIwcmV0cmVhdCUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3ODY0MjUyMDF8MA&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "8", suffix: "Acres", label: "Of curated hillside estate" },
  { value: "240", suffix: "Homes", label: "Exclusive hill-view residences" },
  { value: "5,800", suffix: "ft", label: "Above sea level, in pure air" },
  { value: "40+", suffix: "", label: "Bespoke wellness amenities" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "The Ascent",
    body:
      "Above the noise, beneath the pines. Sarrgosa rises where the Kasauli air turns clean and the horizon opens into layered Himalayan blue. Every threshold is an invitation to breathe deeper.",
  },
  {
    no: "02",
    title: "The Sanctuary",
    body:
      "Eight private acres, gated and unhurried. A community shaped for the few — where stone, timber and glass frame the forest, and every home holds a view worth waking up to.",
  },
  {
    no: "03",
    title: "The Ritual",
    body:
      "Conscious luxury is a daily practice. Cold mornings by the infinity edge, forest walks, spa evenings, slow dinners under the deodars. Wellness woven into the architecture of the everyday.",
  },
  {
    no: "04",
    title: "The Legacy",
    body:
      "Crafted by Diamond India Builders with obsessive detail and enduring materials. Sarrgosa is not built for a season — it is built to be passed down, gently, for generations.",
  },
];

export const AMENITIES = [
  {
    key: "pool",
    title: "Infinity-Edge Pool",
    desc: "A heated horizon pool that dissolves into the valley mist.",
    span: "lg:col-span-2 lg:row-span-2",
    image: IMAGES.pool,
  },
  {
    key: "spa",
    title: "Alpine Wellness Spa",
    desc: "Hydrotherapy, steam and quiet water.",
    span: "",
    image: IMAGES.spa,
  },
  {
    key: "sauna",
    title: "Cedar Sauna & Steam",
    desc: "Warmth carved from timber.",
    span: "",
    image: IMAGES.sauna,
  },
  {
    key: "trails",
    title: "Private Forest Trails",
    desc: "Kilometres of deodar and pine, all your own.",
    span: "lg:col-span-2",
    image: IMAGES.forest,
  },
];

export const AMENITY_TAGS = [
  "Grand Clubhouse",
  "Sky Yoga Deck",
  "24×7 Concierge",
  "Fine-Dining Lounge",
  "Library & Cigar Room",
  "EV Charging",
  "Kids' Discovery Zone",
  "Meditation Amphitheatre",
  "Organic Kitchen Garden",
  "Valet & Security",
];

export const RESIDENCES = [
  {
    name: "The Deodar",
    type: "Studio Apartment",
    size: "750 sq.ft.",
    image: "/assets/studio-interior.webp",
    note: "A perfectly composed sanctuary — an open living-sleep space, a sleek kitchenette and a private balcony framing the sunrise over the hills.",
  },
  {
    name: "The Cedar",
    type: "1 BHK Hill Residence",
    size: "1,000 sq.ft.",
    image: "/assets/onebhk-living.webp",
    note: "A gracious bedroom, a light-filled living room and a generous deck — designed for slow mornings and unhurried mountain evenings.",
  },
];

export const COMMUNITY = [
  {
    no: "01",
    kicker: "Sound & Stillness",
    title: "The Healing Studio",
    desc: "A dedicated sanctuary for sound baths, breathwork and meditation — Tibetan singing bowls, a bronze gong and floor cushions, wrapped in glass that opens to the dawn hills.",
    tags: ["Sound Bath", "Breathwork", "Guided Meditation"],
    image: "/assets/community-healing.webp",
  },
  {
    no: "02",
    kicker: "Ideas in the Air",
    title: "The Brainstorm Studio",
    desc: "A light-filled ideation space with a writable glass wall and warm collaboration tables — where founders, writers and dreamers think out loud, together.",
    tags: ["Writable Walls", "Workshops", "Mastermind Circles"],
    image: "/assets/community-brainstorm.webp",
  },
  {
    no: "03",
    kicker: "Work, Elevated",
    title: "The Co-Working Lounge",
    desc: "A fully-equipped mountain office — private desks, high-speed connectivity, acoustic focus pods and a communal oak table, all facing the misty ridgelines.",
    tags: ["High-Speed Wi-Fi", "Focus Pods", "Private Desks"],
    image: "/assets/community-coworking.webp",
  },
  {
    no: "04",
    kicker: "Gather & Savour",
    title: "Live Global Beverage Counter",
    desc: "A living café at the heart of the community — freshly pulled espresso, single-origin pour-overs and loose-leaf teas from around the world, served all day.",
    tags: ["Barista Bar", "Global Teas", "Fresh Roasts"],
    image: "/assets/community-beverages.webp",
  },
];

export const LOCATION = [
  { place: "Kasauli Mall Road", meta: "12 min drive" },
  { place: "Dharampur", meta: "10 min drive" },
  { place: "Chandigarh City", meta: "60 km · 1 hr 30 min" },
  { place: "Chandigarh Airport", meta: "65 km · 1 hr 40 min" },
  { place: "New Delhi", meta: "300 km · 5 hr 30 min" },
];

export const ADDRESS = "Subathu Road, Dharampur / Kasauli, Himachal Pradesh";
export const MAPS_URL = "https://maps.app.goo.gl/UJxc9qc1toCjcbmG6";

export const CONTACT = {
  phone: "+91 94160 04600",
  phoneHref: "tel:+919416004600",
  email: "diamondindiabuilders@gmail.com",
  emailHref: "mailto:diamondindiabuilders@gmail.com",
  instagram:
    "https://www.instagram.com/diamondindiabuilders?igsh=MW1oZHZsYnhzNm03aA==",
  instagramHandle: "@diamondindiabuilders",
};

export const CONFIG_OPTIONS = [
  "Studio Apartment — The Deodar",
  "1 BHK — The Cedar",
  "Just exploring",
];
